<div style="float: left; margin-bottom: 2rem; margin-top: 1rem">
  <button (click)="openCreateCategoryDialog()" color="primary"
          mat-raised-button>{{ 'Create Category' | translate }}</button>
</div>

<table [dataSource]="categories" class="mat-elevation-z8" mat-table>
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell> {{ 'Name' | translate }}</th>
    <td *matCellDef="let category" mat-cell> {{category.name}} </td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th *matHeaderCellDef mat-header-cell> {{ 'Edit' | translate }} </th>
    <td *matCellDef="let category" mat-cell>
      <a (click)="openEditCategoryDialog(category)"
         style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th *matHeaderCellDef mat-header-cell> {{ 'Remove' | translate }} </th>
    <td *matCellDef="let category" mat-cell>
      <a (click)="deleteCategory(category.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
</table>
